var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19V16.2981H18V19H0ZM3.6 12.1673H4.71285L12.1829 4.70564L11.617 4.13081L11.0563 3.57826L3.6 11.0536V12.1673ZM2.25 13.5182V10.4786L12.3388 0.39651C12.4691 0.266066 12.6171 0.16737 12.7827 0.100422C12.9481 0.0334745 13.1203 0 13.2993 0C13.4784 0 13.6518 0.0334745 13.8195 0.100422C13.9872 0.16737 14.1409 0.27072 14.2805 0.41047L15.3623 1.50678C15.502 1.63722 15.6029 1.78665 15.6652 1.95507C15.7274 2.12335 15.7585 2.29732 15.7585 2.477C15.7585 2.64542 15.727 2.81286 15.6638 2.97933C15.6007 3.14595 15.5002 3.29824 15.3623 3.43619L5.2875 13.5182H2.25ZM12.1829 4.70564L11.617 4.13081L11.0563 3.57826L12.1829 4.70564Z",
    fill: "#5A606C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a673f9307feeab108aa722e560acf976.svg";
export { ForwardRef as ReactComponent };